// automatically generated by the FlatBuffers compiler, do not modify
/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */
import * as flatbuffers from 'flatbuffers';
export class Position {
    bb = null;
    bb_pos = 0;
    __init(i, bb) {
        this.bb_pos = i;
        this.bb = bb;
        return this;
    }
    static getRootAsPosition(bb, obj) {
        return (obj || new Position()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
    }
    static getSizePrefixedRootAsPosition(bb, obj) {
        bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
        return (obj || new Position()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
    }
    x() {
        const offset = this.bb.__offset(this.bb_pos, 4);
        return offset ? this.bb.readFloat64(this.bb_pos + offset) : 0.0;
    }
    y() {
        const offset = this.bb.__offset(this.bb_pos, 6);
        return offset ? this.bb.readFloat64(this.bb_pos + offset) : 0.0;
    }
    static startPosition(builder) {
        builder.startObject(2);
    }
    static addX(builder, x) {
        builder.addFieldFloat64(0, x, 0.0);
    }
    static addY(builder, y) {
        builder.addFieldFloat64(1, y, 0.0);
    }
    static endPosition(builder) {
        const offset = builder.endObject();
        return offset;
    }
    static createPosition(builder, x, y) {
        Position.startPosition(builder);
        Position.addX(builder, x);
        Position.addY(builder, y);
        return Position.endPosition(builder);
    }
}
//# sourceMappingURL=position.js.map